function pad(n) {
    return n < 10 ? '0' + n : n
}

window.correctValue = function (item) {
    var val = $(item).val().split(':');
    var recalculatedVal = Math.round(parseInt(val[1]) / 15) * 15;
    if (recalculatedVal > 45) {
        recalculatedVal = 45;
    }

    $(item).val(val[0] + ":" + pad(recalculatedVal));
}

window.checkTravelData = function (key) {
    var show = false;
    if ($('select[name=travel_minutes_there]  option:selected').val() !== $('#th_minutes_there_' + key + '  option:selected').val()) show = true;
    if ($('select[name=travel_minutes_back]').val() !== $('#th_minutes_back_' + key + '  option:selected').val()) show = true;
    if ($('input[name=amount_kms]').val() !== $('#th_amount_kms_' + key).val()) show = true;
    if (show) {
        $("#travel_remarks_" + key).removeClass('d-none');
        $("#th_remarks_" + key).prop('required', true);
    } else {
        $("#travel_remarks_" + key).addClass('d-none');
        $("#th_remarks_" + key).prop('required', false);
    }
}

//show a message if hours are changed but not saved
var changes = 0
var clicked = false

$("#backbutton-overlay-hours").on("click", function (e) {
    if (changes > 0) {
        if (clicked === false) {
            clicked = true
            showAlertMessage("De wijzigingen zijn niet opgeslagen. Ga nogmaals terug om wijzigingen te negeren");
            e.stopImmediatePropagation();
            e.preventDefault();
            return false;
        }
    }
})

$("#overlayHours input").on("change", function (event) {
    changes++
});

$("#overlayHours select").on("change", function (event) {
    changes++
});


$(function () {
    if (typeof(travel_time_from_planning) !== 'undefined' && typeof(amount_kms_from_planning) !== 'undefined') {
        window.messageIncorrectBreakOrTravel = "Let op: reistijd en/of afstand zijn niet conform Google Maps. Wijzigingen enkel" +
            " na afstemming met de planning. De reistijd volgens de planning is " +
            travel_time_from_planning + " minuten en de reisafstand is " + amount_kms_from_planning + " km.";

        window.messageMainShownTravelTime = 0;
        window.messageGeneralHoursTravelTime = 0;

        checkInputsByDefaultsFromWorkorder("workorderForm",
            "workorder-save-button",
            "leave_mcn_time",
            "end_work",
            "amount_kms",
            "input",
            "messageMainShownTravelTime",
            travel_time_from_planning,
            amount_kms_from_planning
        );

        checkInputsByDefaultsFromWorkorder("workOrderGeneralHoursForm",
            "workorder-general-hours-save-button",
            "leave_mcn_time",
            "end_time",
            "amount_kms",
            "input",
            "messageGeneralHoursTravelTime",
            travel_time_from_planning,
            amount_kms_from_planning
        );

        $("form[id*='employeeForm']").each(function (key, item) {
            var submitbutton = $("#" + $(item).attr("id") + ' button[id*="workorder-save-hours-button"]')
            window[$(item).attr("id")] = 0
            checkInputsByDefaultsFromWorkorder($(item).attr("id"),
                submitbutton.attr("id"),
                "leave_mcn_time",
                "end_time",
                "amount_kms",
                "input",
                $(item).attr("id"),
                travel_time_from_planning,
                amount_kms_from_planning
            );
        })
    }
});

function checkInputsByDefaultsFromWorkorder(id, button_id, input1, input2, input3, inputtype, message, checkvalue1, checkvalue2) {
    $("#" + button_id).on("click", function (event) {
        var errors = getTimeInputErrorsFromTimeSpan(id, input1, checkvalue1)
            + getTimeInputErrorsFromTimeSpan(id, input2, checkvalue1)
        var errors2 = getTimeInputErrorsFromSingleInput(id, input3, inputtype, checkvalue2)

        if (errors === 0 && errors2 === 0 || window[message] > 1) {
            $("#" + id).submit();
        } else {
            window[message]++
            showAlertMessage(messageIncorrectBreakOrTravel);
            event.preventDefault();
            return false;
        }
    });
}

function getTimeInputErrorsFromTimeSpan(id, input_name, checkvalue) {
    var errors = 0;
    $(`#${id} input[name^='${input_name}']`).each(function () {
        var input1 = $(this);
        var input2 = $(this).closest("div").next("div").find("input");
        if (!checkTimeSpanInRange(input1, input2, checkvalue)) {
            errors++
        }
    })

    return errors;
}

function getTimeInputErrorsFromSingleInput(id, input_name, inputtype, checkvalue) {
    var errors = 0;
    $(`#${id} ${inputtype}[name^='${input_name}']`).each(function () {
        if (parseInt($(this).val()) !== checkvalue) {
            errors++
        }
    })
    return errors;
}

function checkTimeSpanInRange(input1, input2, value) {
    //just comparing times so date is not needed here
    var timeArray1 = $(input1).val().split(":");
    var date1 = new Date(null, null, null, timeArray1[0], timeArray1[1]);
    var timeArray2 = $(input2).val().split(":");
    var date2 = new Date(null, null, null, timeArray2[0], timeArray2[1]);

    // the following is to handle cases where the times are on the opposite side of
    // midnight e.g. when you want to get the difference between 9:00 PM and 5:00 AM
    if (date2 < date1) {
        date2.setDate(date2.getDate() + 1);
    }

    var diffInMinutes = (date2 - date1) / 1000 / 60;

    if (diffInMinutes === value) {
        return true;
    }
    return false;
}



// WEBPACK FOOTER //
// ./resources/js/components/workordersMobile.js